import { disposables as o } from "../../utils/disposables.js";
import { createStore as a$1 } from "../../utils/store.js";
import { adjustScrollbarPadding as d$1 } from "./adjust-scrollbar-padding.js";
import { handleIOSLocking as d } from "./handle-ios-locking.js";
import { preventScroll as r } from "./prevent-scroll.js";
function m(e) {
  let n = {};
  for (let t of e) Object.assign(n, t(n));
  return n;
}
let a = a$1(() => /* @__PURE__ */ new Map(), { PUSH(e, n) {
  var o$1;
  let t = (o$1 = this.get(e)) != null ? o$1 : { doc: e, count: 0, d: o(), meta: /* @__PURE__ */ new Set() };
  return t.count++, t.meta.add(n), this.set(e, t), this;
}, POP(e, n) {
  let t = this.get(e);
  return t && (t.count--, t.meta.delete(n)), this;
}, SCROLL_PREVENT({ doc: e, d: n, meta: t }) {
  let o2 = { doc: e, d: n, meta: m(t) }, c = [d(), d$1(), r()];
  c.forEach(({ before: r2 }) => r2 == null ? void 0 : r2(o2)), c.forEach(({ after: r2 }) => r2 == null ? void 0 : r2(o2));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
a.subscribe(() => {
  let e = a.getSnapshot(), n = /* @__PURE__ */ new Map();
  for (let [t] of e) n.set(t, t.documentElement.style.overflow);
  for (let t of e.values()) {
    let o2 = n.get(t.doc) === "hidden", c = t.count !== 0;
    (c && !o2 || !c && o2) && a.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && a.dispatch("TEARDOWN", t);
  }
});
export {
  a as overflows
};
